import PageShell from "./PageShell";

const ROLES = [
  { title: "Senior Refining Engineer", type: "Full-time · Pune", desc: "Lead refining operations across gold and silver lines with focus on yield optimization." },
  { title: "Assay Laboratory Analyst", type: "Full-time · Pune", desc: "Operate XRF, fire-assay and ICP-OES instruments to certify purity standards." },
  { title: "Quality & Compliance Lead", type: "Full-time · Pune", desc: "Drive QC processes, audits, and certifications across the facility." },
  { title: "Logistics & Vault Operations", type: "Full-time · Pune", desc: "Manage secured intake, vault movements and insured dispatch workflows." },
];

export default function Careers() {
  return (
    <PageShell
      testId="careers-page"
      eyebrow="Careers"
      title="Build the future of refining."
      intro="Join a team that values precision, ethics and craftsmanship. We are always looking for exceptional engineers, analysts and operators."
      seo={{
        title: "Careers · Agroya Refinery LLP",
        description: "Open roles at Agroya Refinery — refining engineers, laboratory analysts, quality & compliance and logistics specialists in Pune, India.",
        canonical: "https://agroya1935.com/careers",
      }}
    >
      <div className="grid gap-4 not-prose">
        {ROLES.map((r, i) => (
          <div key={i} data-testid={`role-${i}`} className="p-6 border border-[#E5E5E5] rounded-lg bg-white lift-card">
            <div className="font-heading text-xl font-medium text-[#0A0A0A]">{r.title}</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] font-semibold mt-1">{r.type}</div>
            <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">{r.desc}</p>
            <a href="mailto:careers@agroyarefinery.com" className="mt-4 inline-block text-sm font-medium text-[#0A0A0A] border-b border-[#D4AF37] hover:text-[#D4AF37]">
              Apply →
            </a>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
